import _values from 'lodash/values';
import React from 'react';
export const InfoList = ({ data }) => {
    return (React.createElement("ul", { className: "list-disc ml-7" }, _values(data).map((text) => (React.createElement("li", { className: "indent-[-4px]", key: text }, text.endsWith('.') ? text.slice(0, text.length - 1) : text)))));
};
export default InfoList;
